/**
 * Csv Schema of TipoRelatorio
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {TipoRelatorio} from '@/model/resource/TipoRelatorio'

/* TODO: review generated schema */
export class CsvTipoRelatorioSchema extends Schema {
  readonly name = 'CsvTipoRelatorio'

  readonly fieldSet: FieldSet<TipoRelatorio> = {
    idTipoRelatorioPk: schema => schema.model.idTipoRelatorioPk,
    formatoArquivoRelatorio: schema =>
      schema.model.formatoArquivoRelatorio?.$id ?? null,
    descricao: schema => schema.model.descricao,
  }
}
